import { z } from "zod";
import { SowChangeHoldLevelSchema } from "@remi/enums/sow-change/hold-level";

export const SowChangeBlockedProjectSchema = z.object({
  projectId: z.number().int(),
  holdLevel: SowChangeHoldLevelSchema,
});
export type SowChangeBlockedProject = z.infer<typeof SowChangeBlockedProjectSchema>;

export const SowChangeBlockedProjectRequestSchema = SowChangeBlockedProjectSchema.extend({
  holdLevel: SowChangeHoldLevelSchema.optional(),
});
export type SowChangeBlockedProjectRequest = z.infer<typeof SowChangeBlockedProjectRequestSchema>;
